import { TradingTotalPeriodData } from "models/functionModels/reportFunctions/TradingTotalsReportFunction";
import { createSlice } from "@reduxjs/toolkit";

interface state {
    reportData : TradingTotalPeriodData[],
    reportView : TradingTotalPeriodData[]
}

export const initialState: state = {
    reportData: [],
    reportView: []
}

const tradingTotalsReportPageSlice = createSlice({
    name: "tradingTotalsReportPageSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        updateReportData: (state, action) => {
            return {
                ...state,
                ["reportData"]: action.payload
            };
        },
        updateReportView: (state, action) => {
            return {
                ...state,
                ["reportView"]: action.payload
            }
        },
        cleanTradingTotals: (state) => {
            return {
                ...state,
                ["reportData"]: [],
                ["reportView"]: []
            }
        }        
    }
});

export const {
    updateReportData,
    updateReportView,
    cleanTradingTotals,
} = tradingTotalsReportPageSlice.actions;

export default tradingTotalsReportPageSlice.reducer;